import {
  InsuranceCoverage,
  SopSicknessLeaveCoverage,
} from "Store/interfaces/products/coverage";

import { INSURANCE_NAME_VALUE } from "Store/interfaces/products";
import { InsuranceProduct } from "Store/interfaces/products/checkout";
import { isDefined } from "Utils/functions";
import { getAgeFromDate } from "Validation/dateValidaton";

export const isSopSicknessLeaveCoverage = (
  coverage?: InsuranceCoverage,
): boolean =>
  isDefined(coverage) &&
  coverage === SopSicknessLeaveCoverage.SOP_SICKNESS_LEAVE;

export const getCustomerAge = (
  dateOfBirth: string | undefined,
): number | undefined => {
  return isDefined(dateOfBirth)
    ? getAgeFromDate(new Date(dateOfBirth))
    : undefined;
};

export const isSopProduct = (products: InsuranceProduct[]): boolean =>
  products.some(
    (product) => product.name === INSURANCE_NAME_VALUE.SOP_SICKNESS_LEAVE,
  );
